// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__0WjMc","footer":"styles_footer__DliGt"};